import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { Modal, Carousel } from 'antd';
import styles from './index.module.scss';
import Header from './Header';
import PresentWord from './PresentWord';
import { ReactComponent as IconClose } from '@/images/icons/mail/icon-close2.svg';
import { ReactComponent as IconArrowLeft } from '@/images/icons/mail/arrow-left.svg';
import { ReactComponent as IconArrowRight } from '@/images/icons/mail/arrow-right.svg';
import PraiseMedalItem from '../PraiseMedal';
import { getIn18Text } from 'api';
const PersonPraiseMedal = props => {
    const { personMedalData, isModalVisible, from, toIndex = 0, handleCancel, praiseOwner = false } = props;
    const carousel = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (carousel && toIndex) {
            setCurrentIndex(toIndex);
            switchIndex(toIndex);
        }
    }, []);
    const prev = () => {
        carousel.current.prev();
    };
    const next = () => {
        carousel.current.next();
    };
    const afterChange = (index) => {
        setCurrentIndex(index);
    };
    const switchIndex = (index) => {
        carousel.current.goTo(index);
    };
    const medalContentLeft = () => {
        if (!personMedalData)
            return null;
        return (React.createElement("div", { className: styles.medalContentLeft },
            React.createElement(Carousel, { ref: carousel, className: styles.carouselWrap, afterChange: afterChange }, personMedalData.map((medalData) => {
                return (React.createElement(PraiseMedalItem, Object.assign({ key: medalData.id }, {
                    medalData: medalData,
                    styles: {
                        medalWidth: 180,
                        medalHeight: 180,
                        containStyle: {
                            height: 426,
                        },
                    },
                    from,
                    praiseOwner,
                })));
            })),
            React.createElement("div", { className: styles.switchWrap },
                currentIndex === 0 ? React.createElement(IconArrowLeft, null) : React.createElement(IconArrowRight, { style: { transform: 'rotate(180deg)' }, onClick: prev }),
                React.createElement("div", { className: styles.switchList },
                    React.createElement("div", { style: {
                            display: 'flex',
                            transition: '0.5s',
                            marginLeft: currentIndex - 3 > 0 ? -(currentIndex - 3) * (52 + 17) : 0,
                        } }, personMedalData.map((medalData, index) => {
                        return (React.createElement("div", { className: classnames(styles.switchItem, { [styles.switchItemsChange]: index === currentIndex }), key: medalData.id, onClick: () => switchIndex(index) },
                            React.createElement("img", { src: medalData.count > 0 ? medalData.imageUrl : medalData.grayImageUrl, alt: "" })));
                    }))),
                currentIndex === personMedalData.length - 1 ? React.createElement(IconArrowLeft, { style: { transform: 'rotate(180deg)' } }) : React.createElement(IconArrowRight, { onClick: next }))));
    };
    const praiseLetterNone = () => {
        return (React.createElement("div", { className: styles.praiseLetterNone },
            React.createElement("span", null, getIn18Text('WEIHUODEGAIXUN'))));
    };
    const medalContentRight = () => {
        const currentPraiseLetter = personMedalData[currentIndex].praiseLetters;
        return (React.createElement("div", { className: styles.medalContentRight }, (currentPraiseLetter === null || currentPraiseLetter === void 0 ? void 0 : currentPraiseLetter.length)
            ? currentPraiseLetter.map(praiseLetter => {
                return React.createElement(PresentWord, { praiseLetter: praiseLetter, key: praiseLetter.id });
            })
            : praiseLetterNone()));
    };
    return (React.createElement(Modal, { title: React.createElement(Header, null), wrapClassName: styles.personalMedal, width: 716, bodyStyle: { padding: 0 }, visible: isModalVisible, footer: null, centered: true, closeIcon: React.createElement(IconClose, null), onCancel: handleCancel },
        React.createElement("div", { className: styles.medalContent },
            medalContentLeft(),
            medalContentRight())));
};
export default PersonPraiseMedal;
